// @flow
import gql from 'graphql-tag.macro';
import { useMutation } from '@apollo/react-hooks';

import type { MutationTuple } from '@apollo/react-hooks';

export const MUTATION_ADD_RETAILER_LOGS = gql`
  mutation addRetailerLogs($input: RetailerLogInput!) {
    addRetailerLogs(input: $input) {
      id
    }
  }
`;

export const useMutationAddRetailerLogs = (): MutationTuple<any, any> => {
  return useMutation(MUTATION_ADD_RETAILER_LOGS);
};
